import React from 'react'
import { Spinner } from '@mindfulchefuk/components/Loader'
import { Flex } from '@mindfulchefuk/design-system'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingBasketFooterEmpty } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingBasketTotalFooter/OnboardingBasketTotalFooterCopy/OnboardingBasketFooterEmpty'
import { OnboardingBasketFooterTotals } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingBasketTotalFooter/OnboardingBasketTotalFooterCopy/OnboardingBasketFooterTotals'

export const OnboardingBasketTotalFooterCopy = ({
  totalsData,
}: {
  totalsData: {
    total: string
    totalAfterDiscount: string
  }
}) => {
  const {
    maximumRecipesForPortion,
    minimumRecipesForPortion,
    isFetchingOnboardingPreviewData: isLoading,
    totalNumberOfRecipes,
  } = useChooseRecipesContext()

  const isEmpty = totalNumberOfRecipes === 0

  return (
    <Flex
      pr={{ sm: 40 }}
      position="relative"
      minHeight={['65px', '80px']}
      alignItems="center"
      justifyContent={['space-between', 'flex-end']}
      width="100%"
    >
      {isLoading && (
        <Flex
          position="absolute"
          bg="white.50"
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="flex-end"
          data-testid="loading"
        >
          <Spinner size={24} />
        </Flex>
      )}

      {isEmpty && (
        <OnboardingBasketFooterEmpty
          min={minimumRecipesForPortion}
          max={maximumRecipesForPortion}
        />
      )}

      {!isEmpty && !isLoading && (
        <OnboardingBasketFooterTotals totalsData={totalsData} />
      )}
    </Flex>
  )
}
